import * as tslib_1 from "tslib";
import { Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
var Field = (function () {
    function Field() {
    }
    Object.defineProperty(Field.prototype, "key", {
        get: function () { return this.field.key; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Field.prototype, "formControl", {
        get: function () { return this.field.formControl || this.form.get(this.key); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Field.prototype, "templateOptions", {
        get: function () {
            console.warn(this.constructor.name + ": 'templateOptions' is deprecated. Use 'to' instead.");
            return this.to;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Field.prototype, "to", {
        get: function () { return this.field.templateOptions; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Field.prototype, "valid", {
        get: function () {
            console.warn(this.constructor.name + ": 'valid' is deprecated. Use 'showError' instead.");
            return this.showError;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Field.prototype, "showError", {
        get: function () { return this.options.showError(this); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Field.prototype, "id", {
        get: function () { return this.field.id; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Field.prototype, "formState", {
        get: function () { return this.options.formState || {}; },
        enumerable: true,
        configurable: true
    });
    return Field;
}());
export { Field };
tslib_1.__decorate([
    Input(),
    tslib_1.__metadata("design:type", FormGroup)
], Field.prototype, "form", void 0);
tslib_1.__decorate([
    Input(),
    tslib_1.__metadata("design:type", Object)
], Field.prototype, "field", void 0);
tslib_1.__decorate([
    Input(),
    tslib_1.__metadata("design:type", Object)
], Field.prototype, "model", void 0);
tslib_1.__decorate([
    Input(),
    tslib_1.__metadata("design:type", Object)
], Field.prototype, "options", void 0);
//# sourceMappingURL=field.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ng-formly/lib/src/core/src/templates/field.js
// module id = 183
// module chunks = 3